<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isKonfirmasi ? 'Konfirmasi' : 'Buat' }} Pinjaman</h5>
            </b-card-header>
            <b-card-body v-show="isKonfirmasi">
                <p>Pinjaman sebesar Rp. {{ formatNumber(form.nominal) }} oleh {{ form.supplier ? form.supplier.name : '-' }}.</p>
                <p>Dengan metode pembayaran {{ form.metode ? form.metode.name.toUpperCase() : '-' }}.</p>
            </b-card-body>
            <b-card-body v-show="!isKonfirmasi">
                <div class="form-group">
                    <label class="form-control-label">Nama</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect :class="'w-auto flex-grow-1'" v-validate="'required'" name="supplier" v-model="form.supplier" :options="supplierOptions" :placeholder="'Pilih supplier'" :searchable="true"
                            label="name" track-by="id" :allowEmpty="false" :show-labels="false"></multiselect>
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="selectSupplier = true"><i class="fas fa-search"></i> Pilih</button>
                        </div>
                    </div>
                    <span class="text-danger">{{ errors.first('supplier') }}</span>
                </div>

                <div class="form-group">
                    <label>Nominal</label>
                    <input v-validate="'required|min:0'" min="0" v-model="form.nominal" type="number" name="nominal" class="form-control">
                    <span class="text-danger">{{ errors.first('nominal') }}</span>
                </div>

                <div class="form-group">
                    <label class="form-control-label">Metode</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect class='w-auto flex-grow-1' v-validate="'required'" name="metode" v-model="form.metode" :options="metodeOptions" :placeholder="'Pilih metode'" :searchable="true"
                            label="value" track-by="name" :allowEmpty="false" :show-labels="false"></multiselect>
                    </div>
                    <span class="text-danger">{{ errors.first('metode') }}</span>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <template v-if="isKonfirmasi">
                    <button :disabled="isLoading" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                    <button :disabled="isLoading" @click="save" type="button" class="btn btn-primary mr-2">OK</button>
                </template>
                <template v-else>
                    <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                    <button :disabled="isLoading" @click="pinjam" type="button" class="btn btn-primary mr-2">Pinjam</button>
                </template>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectSupplier" size="lg" :hide-header="true" :hide-footer="true">
            <supplier-selector :selected="supplierOptions" @selected="supplierSelected" @cancel="selectSupplier = false"></supplier-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import SupplierSelector from '../suppliers/Selector';

export default {
    name: "pinjaman-supplier-form",

    props: {
    },

    components: {
        Multiselect,
        SupplierSelector,
    },

    data() {
        return {
            form: {
                supplier: null,
                nominal: null,
                metode: null,
            },
            selectSupplier: false,
            supplierOptions: [],
            isKonfirmasi: false,
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        this.resetForm();
    },

    computed: {
    },

    watch: {
    },

    methods: {
        resetForm() {
            this.form = Object.assign({}, {
                supplier: null,
                nominal: null,
                metode: null,
            });
        },

        pinjam() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isKonfirmasi = true;
                }
            });
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        save() {
            let self = this;

            self.isLoading = true;
            let data = {
                supplier_id: self.form.supplier ? self.form.supplier.id : null,
                nominal: self.form.nominal,
                metode: self.form.metode ? self.form.metode.name : null,
            }

            self.$Progress.start();
            axios({
                method: 'post',
                url: '/api/pinjaman-suppliers/pinjaman',
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        supplierSelected(supplier) {
            let self = this;

            self.supplierOptions.push(supplier);
            self.form.supplier = Object.assign({}, supplier);
            self.selectSupplier = false;
        },
    },
}
</script>
